// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"911dbf34","769":"72ccbfc7"}[chunkId] + ".chunk.js";
};